export const base_url = "https://api.sirgil.ke/api/users/";


// export const base_url = "http://localhost:8000/api/users/";



//Common 
//login 
export const Loginurl = base_url + "login"
//request pass change
export const Requestpasschangeurl = base_url + "requestpasschange"
//validate reset passcode
export const Validatepasscodeurl = base_url + "validateresetcode"
//reset pass
export const Resetpassurl = base_url + "resetpassword"

//Site visits
//record site vist
export const Recordsitevisiturl = base_url + "recordsitevisit"
//fetch site visits 
export const Fetchsitevisitsurl = base_url + "fetchsitevisits"

//partners
//fetch partner requests
export const Fetchpartnerrequestsurl = base_url + "fetchpartnerrequests"
//post perner request
export const Storepartnerrequesturl = base_url + "storepartnerrequest"


//Messages
//Post Message
export const Postmessageurl = base_url + "postmessage"
//fetch my messages 
export const Fetchconversationsurl = base_url + "fetchconversations"
//fetch message conter
export const Fetchmessagecounterurl = base_url + "fetchmessagescounter"
//admin fetch conversatiobns
export const Adminfetchconversationsurl = base_url + "adminfetchconversations"
//change convo status
export const Changeconvostatusurl = base_url + "changeconvostatus"
//post admin message
export const Postadminmessageurl = base_url + "postadminmessage"


//Users
//update user info
export const Updateuserinfourl = base_url + "updateuserinfo"
//update profilepic url
export const Updateprofilepicurl = base_url + "updateprofilepic"
//fetch accounts
export const Fetchaccountsurl = base_url + "fetchaccounts"
//add agenturl
export const Adduserurl = base_url + "adduser"
//delete user
export const Deleteuserurl = base_url + "deleteuser";






